import { gql } from 'graphql-request'

export const QueryTeamMember = gql`
  fragment FragmentTeamMember on TeamMemberModelRecord {
    __typename
    id
    name
    role
    memberType
    textAlignment
    description
    profilePhoto {  
      title
      url
      filename
      mimeType
      width
      height
      responsiveImage {
        sizes
        src
        width
        height
        alt
        title
        base64
      }
    }
  }
`
